/**
 * Hero Logo Scroll Animation
 * Al primo pixel di scroll, il logo enorme si anima automaticamente
 * verso la posizione esatta del logo nell'header
 */
(function() {
  'use strict';

  const heroLogo = document.getElementById('hero-logo-fullscreen');
  if (!heroLogo) return;

  const heroLogoImg = heroLogo.querySelector('.hero-logo-fullscreen__img');

  // Trova il logo nell'header (può essere transparent-logo o logo-normal)
  const headerLogoContainer = document.querySelector('.site-header .header__heading-link');
  const headerLogo = document.querySelector('.site-header .header__heading-logo');

  let isExpanded = true;

  function isMobile() {
    return window.innerWidth < 1025;
  }

  function getHeroStartTop() {
    // Posizione iniziale diversa per mobile e desktop
    return 40;
  }

  function calculateAndApplyTransform() {
    if (!headerLogo || !heroLogoImg || !headerLogoContainer) {
      console.log('Logo elements not found');
      return;
    }

    // Ottieni le dimensioni e posizioni
    const heroImgRect = heroLogoImg.getBoundingClientRect();
    const headerLogoRect = headerLogo.getBoundingClientRect();
    const headerContainerRect = headerLogoContainer.getBoundingClientRect();

    // Calcola la scala: rapporto tra larghezza logo header e logo hero
    const scale = headerLogoRect.width / heroImgRect.width;

    // Posizione iniziale del logo hero (fixed, centered)
    const heroStartTop = getHeroStartTop();
    const heroStartCenterX = window.innerWidth / 2;

    // Calcola l'altezza dell'announcement bar (se presente)
    const announcementBar = document.querySelector('.section-announcement-bar, .announcement-bar, [class*="announcement"]');
    const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;

    // Posizione target: centro del logo header
    // Quando l'header è sticky, si posiziona in top:0 (sotto l'announcement bar che scompare)
    // Quindi dobbiamo calcolare la posizione del logo header come se fosse già sticky
    const headerCenterX = headerContainerRect.left + (headerContainerRect.width / 2);

    // Calcola la posizione Y del logo nell'header quando è sticky (senza announcement bar)
    // headerContainerRect.top attuale - altezza announcement bar = posizione quando sticky
    const headerCenterY = (headerContainerRect.top - announcementBarHeight) + (headerContainerRect.height / 2);

    // Il logo hero dopo la scala avrà questa altezza
    const scaledHeight = heroImgRect.height * scale;

    // Calcola translateY: dalla posizione iniziale alla posizione del logo header
    const translateY = headerCenterY - heroStartTop - (scaledHeight / 2);

    // Calcola translateX se il logo header non è centrato
    const translateX = headerCenterX - heroStartCenterX;

    // Applica le trasformazioni
    heroLogo.style.setProperty('--target-scale', scale.toFixed(4));
    heroLogo.style.setProperty('--target-translateY', translateY.toFixed(1) + 'px');
    heroLogo.style.setProperty('--target-translateX', translateX.toFixed(1) + 'px');

    console.log('Logo transform calculated:', {
      scale: scale.toFixed(4),
      translateY: translateY.toFixed(1),
      translateX: translateX.toFixed(1),
      headerRect: headerLogoRect,
      heroRect: heroImgRect,
      isMobile: isMobile()
    });
  }

  function checkScroll() {
    const shouldBeExpanded = window.scrollY === 0;

    if (shouldBeExpanded !== isExpanded) {
      isExpanded = shouldBeExpanded;

      if (isExpanded) {
        document.body.classList.add('hero-logo-expanded');
        document.body.classList.remove('hero-logo-collapsed');
      } else {
        // Ricalcola la posizione ogni volta che si scrolla
        calculateAndApplyTransform();
        document.body.classList.remove('hero-logo-expanded');
        document.body.classList.add('hero-logo-collapsed');
      }
    }
  }

  // Calcola al caricamento
  window.addEventListener('load', function() {
    // Piccolo delay per assicurarsi che tutto sia renderizzato
    setTimeout(calculateAndApplyTransform, 100);
  });

  // Stato iniziale
  if (window.scrollY === 0) {
    document.body.classList.add('hero-logo-expanded');
  } else {
    setTimeout(function() {
      calculateAndApplyTransform();
      document.body.classList.add('hero-logo-collapsed');
    }, 100);
  }

  window.addEventListener('scroll', checkScroll, { passive: true });

  window.addEventListener('resize', function() {
    calculateAndApplyTransform();
  });

  // Mobile: traccia chiusura menu/search per forzare header bianco
  if (isMobile()) {
    let wasMenuOpen = false;
    let wasModalOpen = false;
    let lastScrollY = window.scrollY;

    // Funzione per verificare lo stato
    function checkMenuModalState() {
      const isMenuOpen = document.documentElement.classList.contains('menu-drawer-open');
      const isModalOpen = document.documentElement.classList.contains('open-modal');

      // Se menu o modal era aperto e ora è chiuso
      if ((wasMenuOpen && !isMenuOpen) || (wasModalOpen && !isModalOpen)) {
        // Se nessun altro menu/modal è aperto, forza header bianco
        if (!isMenuOpen && !isModalOpen) {
          document.body.classList.add('force-header-white');
          console.log('Force header white activated');
        }
      }

      // Aggiorna stato precedente
      wasMenuOpen = isMenuOpen;
      wasModalOpen = isModalOpen;
    }

    // Osserva cambiamenti classe su html
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          checkMenuModalState();
        }
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Inizializza stato
    wasMenuOpen = document.documentElement.classList.contains('menu-drawer-open');
    wasModalOpen = document.documentElement.classList.contains('open-modal');

    // Rimuovi force-header-white quando scrolla verso il basso
    window.addEventListener('scroll', function() {
      const currentScrollY = window.scrollY;

      // Scrollando verso il basso rimuovi forzatura
      if (currentScrollY > lastScrollY && currentScrollY > 5) {
        if (document.body.classList.contains('force-header-white')) {
          document.body.classList.remove('force-header-white');
          console.log('Force header white removed (scroll down)');
        }
      }

      lastScrollY = currentScrollY;
    }, { passive: true });

    // Backup: ascolta anche transitionend sul drawer
    document.addEventListener('transitionend', function(e) {
      if (e.target.classList && e.target.classList.contains('modal-inner')) {
        // Controlla dopo che la transizione del drawer è finita
        setTimeout(checkMenuModalState, 50);
      }
    });
  }
})();
